import React from 'react'
import MasterLayout from '../../masterLayout/MasterLayout'
import Breadcrumb from '../../components/Breadcrumb'
import ListQtyLayer from '../../components/Settings/ListQtyLayer'

const ListQtyPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title='List Quantity File' />
      <ListQtyLayer />
    </MasterLayout>
  )
}

export default ListQtyPage
